/**
 * Farm to Fuel Foods — Scroll Reveal Animations
 * Smooth, professional reveals with stagger effects.
 * Uses IntersectionObserver for performance.
 */
(function () {
  'use strict';

  // Sections to animate on scroll
  var sectionSelectors = [
    '.home-promotion',
    '.home-inline-features',
    '.section__featured-product',
    '.image-with-text-overlay',
    '.faq',
    '.home-full-width-feature',
    '.newsletter',
    '.pxs-newsletter-section',
    '.home-testimonials',
    '.template-collection .product-list-item',
    '.product'
  ];

  function initRevealAnimations() {
    // Add .reveal-on-scroll to all target sections
    sectionSelectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        if (!el.classList.contains('reveal-on-scroll')) {
          el.classList.add('reveal-on-scroll');

          // Stagger for grid children
          if (el.classList.contains('home-inline-features')) {
            el.classList.add('stagger-children');
          }

          // Stagger for FAQ items
          if (el.classList.contains('faq')) {
            el.classList.add('stagger-faq');
          }
        }
      });
    });

    // IntersectionObserver for reveal
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );

      document.querySelectorAll('.reveal-on-scroll').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show everything
      document.querySelectorAll('.reveal-on-scroll').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    // Parallax effect for hero image on scroll
    initHeroParallax();
  }

  function initHeroParallax() {
    var heroImage = document.querySelector('.home-promotion-image');
    if (!heroImage) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrolled = window.pageYOffset;
          var rate = scrolled * 0.15;
          if (rate < 80) {
            heroImage.style.transform = 'translateY(' + rate + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /**
   * Smooth-scroll for anchor navigation links.
   * Handles clicks on links with hash targets (e.g. /#shop, #faq)
   * and accounts for sticky header height.
   */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="#"]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href) return;

      // Extract the hash — works for /#shop, #shop, /page#section
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      var hash = href.substring(hashIndex);
      if (hash === '#' || hash === '') return;

      // If the link has a path before the hash, make sure it's for the current page
      var path = href.substring(0, hashIndex);
      if (path && path !== '/' && path !== window.location.pathname) return;

      var target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      // Close mobile drawer if open
      var mobileDrawer = document.querySelector('.mobile-drawer');
      var drawerOverlay = document.querySelector('.mobile-drawer__overlay');
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        mobileDrawer.classList.remove('is-open');
        document.body.classList.remove('mobile-drawer--open');
        if (drawerOverlay) drawerOverlay.style.display = 'none';
      }

      // Calculate header offset
      var header = document.querySelector('.site-header') || document.querySelector('header');
      var headerHeight = header ? header.offsetHeight : 0;
      var extraPadding = 20;
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - extraPadding;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Update URL without triggering scroll
      if (history.pushState) {
        history.pushState(null, null, hash);
      }
    });

    // Handle direct page load with hash in URL
    if (window.location.hash) {
      var hash = window.location.hash;
      var target = document.querySelector(hash);
      if (target) {
        // Delay to let page fully render
        setTimeout(function () {
          var header = document.querySelector('.site-header') || document.querySelector('header');
          var headerHeight = header ? header.offsetHeight : 0;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }, 400);
      }
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRevealAnimations();
      initSmoothScroll();
    });
  } else {
    initRevealAnimations();
    initSmoothScroll();
  }
})();
